import { forwardRef } from "react";
import type { CSSProperties, ReactNode } from "react";
import { cn } from "@ui/lib/utils";

interface MessagesListProps {
  /**
   * - `top`: stack from the top.
   * - `bottom`: stack from the bottom; top clips when content overflows.
   * - `center`: center vertically while content fits; bottom-anchor and clip the top once content overflows.
   */
  anchor?: "top" | "bottom" | "center";
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  style?: CSSProperties;
}

export const MessagesList = forwardRef<HTMLDivElement, MessagesListProps>(
  ({ anchor = "top", children, className, contentClassName, style }, ref) => {
    return (
      <div ref={ref} style={style} className={cn("tw-relative tw-size-full tw-min-h-0 tw-overflow-hidden", className)}>
        <div
          className={cn(
            "tw-absolute tw-inset-x-0 tw-bottom-0 tw-flex tw-min-h-full tw-w-full tw-flex-col tw-gap-2",
            anchor === "top" ? "tw-justify-start" : "tw-justify-end",
            contentClassName,
          )}
        >
          {anchor === "center" ? (
            <div className='tw-my-auto tw-flex tw-w-full tw-flex-col tw-gap-2'>{children}</div>
          ) : (
            children
          )}
        </div>
      </div>
    );
  },
);

MessagesList.displayName = "MessagesList";
